import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import { TextField } from 'libs/forms/views/fieldTypes/text';

import { FileIcon } from 'apps/repository/views/columns/icon';
import { Column } from 'apps/repository/views/columns/name';
import { Message } from 'apps/repository/views/columns/message';
import {
  RowStyle,
  RowNameInput,
  ActionsColumn,
  ButtonStyled,
} from 'apps/repository/styles';

@withNamespaces()
@observer
export class FolderInput extends React.Component {
  render() {
    const { manager, onlyRow } = this.props;
    const { folderForm, CreateFolder, SetFolderInputVisibility } = manager;
    return (
      <RowStyle noColorChange onlyRow={onlyRow}>
        <FileIcon
          fileInfo={{ reference: { isFolder: true } }}
          addingFolder={true}
        />
        <Column>
          <form
            onSubmit={e => {
              e.preventDefault();
              CreateFolder();
            }}
          >
            <TextField
              fieldStore={folderForm.fieldStores.get('newFolderName')}
              editComponent={RowNameInput}
              validationPosition={{ top: '2px', right: '-22px' }}
            />
          </form>
        </Column>
        <Message />
        <ActionsColumn renaming>
          <ButtonStyled
            text={<Trans>Cancel</Trans>}
            size='xsmall'
            variant='secondary'
            onClick={() => SetFolderInputVisibility(false)}
            outline
          />
          <ButtonStyled
            text={<Trans>Create</Trans>}
            size='xsmall'
            onClick={() => CreateFolder()}
          />
        </ActionsColumn>
      </RowStyle>
    );
  }
}

FolderInput.propTypes = {
  manager: PropTypes.object,
  onlyRow: PropTypes.bool,
};
